import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'key_value_pipe'})
export class KeyValuePipe implements PipeTransform {
  // tslint:disable-next-line
  public transform(object: {[date: string]: any}): Array<{key: string, value: any}> {
    const keys: Array<string> = Object.keys(object);
    return keys.map((element) => {
      return {
        key: element,
        value: object[element],
      };
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/pipes/pipe-key-value.ts